import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/'
import VueLazyload from 'vue-lazyload'
import infiniteScroll from 'vue-infinite-scroll'
import VueCookie from 'vue-cookie'
import 'babel-polyfill'
import './filter'
import Basics from '../config/basics.config'

// import { userInfo } from './api'
import { Breadcrumb, BreadcrumbItem, Upload, Button, Pagination, Checkbox, Icon, Autocomplete, Loading, Message, Notification, Steps, Step, Table, TableColumn, Input, Dialog, Select, Option, Cascader, Form, FormItem, Radio, Tabs, TabPane, Row, Col, Image, DatePicker, Carousel, carouselItem, Tag, Timeline, TimelineItem} from 'element-ui'
// import { getStore } from '/utils/storage'
import VueContentPlaceholders from 'vue-content-placeholders'
Vue.use(VueContentPlaceholders)
Vue.use(Button)
Vue.use(Pagination)
Vue.use(Checkbox)
Vue.use(Icon)
Vue.use(Autocomplete)
Vue.use(Steps)
Vue.use(Step)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Input)
Vue.use(Dialog)
Vue.use(Select)
Vue.use(Option)
Vue.use(Cascader)
Vue.use(Upload)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Radio)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Row);
Vue.use(Col);
Vue.use(Image);
Vue.use(DatePicker)
Vue.use(Carousel)
Vue.use(carouselItem)
Vue.use(Tag)
Vue.use(Timeline)
Vue.use(TimelineItem)

Vue.use(Loading.directive)
Vue.prototype.$loading = Loading.service
Vue.prototype.$notify = Notification
Vue.prototype.$message = Message
Vue.use(infiniteScroll)
Vue.use(VueCookie)
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: '/static/images/lazy.jpg',
  loading: '/static/images/load.gif',
  attempt: 1
})
Vue.config.productionTip = false
// const whiteList = ['/main', '/goods', '/login', '/register', '/goodsDetails', '/search', '/refreshsearch', '/refreshgoods'] // 不需要登录的页面
// router.beforeEach(function (to, from, next) {
//   if (to.path === '/login' || to.path === '/home' || to.path === '/') {
//     next()
//     return
//   }
//   userInfo().then(({data}) => {
//     store.commit('RECORD_USERINFO', {info: data})
//     console.log('router beforeEach to-->', to)
//     next()
//   }).catch(err => {
//     console.log('router.beforeEach, userInfo', err, err.response)
//     if (err.response.status === 401) {
//       if (whiteList.indexOf(to.path) !== -1) { // 白名单
//         console.log('白名单')
//         next()
//       } else {
//         console.log('非白名单')
//         next({ path: '/login' })
//       }
//     }
//   })
// })
/* eslint-disable */

const ua = window.navigator.userAgent.toLowerCase()
const Agents = ['android', 'iphone', 'webos', 'blackberry', 'symbianos', 'windows phone', 'ipad', 'ipod']

// 获取当前域名
const loca = window.location
// 是否有www可以替换
const isRepalce = loca.host.indexOf('www')
// 是否包含wap
const isWap = loca.host.indexOf('wap.')
// 替换www为wap
let wap = `${loca.protocol}//`
if (isRepalce !== -1) {
  wap = loca.href.replace('www', 'wap')
} else {
  wap += `wap.${loca.host}${loca.pathname}`
}
console.log('process.env.WAP_DOMAIN',Basics.WAP_DOMAIN)
for (let i = 0; i < Agents.length; i++) {
  if (ua.indexOf(Agents[i]) > 0 && isWap === -1) {
    window.location.href = Basics.WAP_DOMAIN
    break
  }
}


new Vue({
  el: '#app',
  store,
  router,
	render: h => h(App),
	data: {
    eventHub: new Vue()
  }
})



// WEBPACK FOOTER //
// ./src/main.js